export default {
  HISTORICAL_MORE_FETCH: 'HISTORICAL_MORE_FETCH',
  HISTORICAL_MORE_SUCCESS: 'HISTORICAL_MORE_SUCCESS',
  HISTORICAL_MORE_ERROR: 'HISTORICAL_MORE_ERROR',
  HISTORICAL_LATEST_FETCH: 'HISTORICAL_LATEST_FETCH',
  HISTORICAL_LATEST_SUCCESS: 'HISTORICAL_LATEST_SUCCESS',
  HISTORICAL_LATEST_ERROR: 'HISTORICAL_LATEST_ERROR'
}